import { ExternalIcon } from "@icons/ExternalIcon";
import { FunctionComponent, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { LinkButton } from "@ui-kit/LinkButton/LinkButton";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { setOverlayScreenAction } from "@store/app/appReducer";
import { useAppDispatch } from "@store/store";

import "./StartingPointLink.css";

interface StartingPointLinkProps {
  dayIndex: number | null;
}

const StartingPointLink: FunctionComponent<StartingPointLinkProps> = ({
  dayIndex,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleAddStartingLocationPress = useCallback(() => {
    dispatch(
      setOverlayScreenAction({
        name: "StartingPoint",
        params: {
          dayIndex,
        },
      }),
    );
  }, [dispatch, dayIndex]);

  return (
    <div className="starting-point-link-component">
      <LinkButton
        type="default"
        size="medium"
        color={colors.primary60}
        iconPrefix={<ExternalIcon size={16} svgName="location" />}
        onPress={handleAddStartingLocationPress}>
        {t("screens.plan.addStartPoint")}
      </LinkButton>
    </div>
  );
};

export { StartingPointLink };
